import { Fragment } from 'react';

/** Greek quoted in «guillemets», or a bare run of Greek words. */
const GREEK = /(«[^»]+»|[Ͱ-Ͽἀ-῿]+(?:[\s'’-]+[Ͱ-Ͽἀ-῿]+)*)/;

/**
 * English text with Greek in it: the Greek is set in the Greek face and marked as Greek, so it
 * reads (and is spoken by screen readers) the same as everywhere else.
 */
export function InlineGreek({ text }: { text: string }) {
  const parts = text.split(GREEK);
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <span key={i} className="greek-inline" lang="el">
            {part}
          </span>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        ),
      )}
    </>
  );
}
